import { BankAccount } from '@app/queryTyping';

import { PaymentOption } from '@make-transfer/types/common';

export class SchedulingSettingsService {
  public static isOneTimeScheduledPaymentAllowed = (
    sourceAccount?: BankAccount | null,
    destinationAccount?: BankAccount | null,
    paymentOption?: PaymentOption,
  ) : boolean => {
    const isAllowedForSourceAccount = sourceAccount?.isScheduledPaymentAllowed ?? true;
    const isAllowedForDestinationAccount = destinationAccount?.isScheduledPaymentAllowed ?? true;
    const isAllowedForPaymentOption = paymentOption?.isScheduledPaymentAllowed ?? true;

    return isAllowedForSourceAccount && isAllowedForDestinationAccount && isAllowedForPaymentOption;
  };

  public static isRecurringPaymentsAllowed = (
    sourceAccount?: BankAccount | null,
    destinationAccount?: BankAccount | null,
    paymentOption?: PaymentOption,
  ) : boolean => {
    const isAllowedForSourceAccount = sourceAccount?.isRecurringPaymentsAllowed ?? true;
    const isAllowedForDestinationAccount = destinationAccount?.isRecurringPaymentsAllowed ?? true;
    const isAllowedForPaymentOption = paymentOption?.isRecurringPaymentsAllowed ?? true;

    return isAllowedForSourceAccount && isAllowedForDestinationAccount && isAllowedForPaymentOption;
  };
}
